<template>
  <v-card-title>
    <slot />
  </v-card-title>
</template>
